const animationsSx = {
    flash: {
        '@keyframes flash': {
            '50%': {
                opacity: 0
            }
        },
        animation: 'flash 1s linear infinite'
    },
    attack: {
        '@keyframes shake': {
            '0%': { transform: 'translate(0, 0)' },
            '20%': { transform: 'translate(-10px, 0)' },
            '30%': { transform: 'translate(10px, 0)' },
            '50%': { transform: 'translate(-10px, 0)' },
            '60%': { transform: 'translate(10px, 0)' },
            '100%': { transform: 'translate(0, 0)' }
        },
        animation: 'shake 1.25s cubic-bezier(.36, .07, .19, .97) infinite'
    }
};

export default animationsSx;